export const items: Array<string> = [
  'This project has purpose and potential',
  'Github has active development activity',
  'Smart contract audit resuits are positive',
  'Devs are not anon or I am comfortable with them',
  'Tokenomics are generally sound',
  'This does not look like a rug or scam',
];
